'use memo';
import { createFileRoute } from '@tanstack/react-router';

import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';

import { ValueTypeSelectionPage } from './-components/ValueTypeSelectionPage';

/**
 * 価値（Value）追加経路選択画面 (route 登録)。
 *
 * 本体は `-components/ValueTypeSelectionPage.tsx` に分離 (playbook §3.18:
 * AttributeCard + ActionButton + Grid + useNavigate + useTranslation の
 * generic を route 直下 inline すると cascade)。
 *
 * Issue 側 (`/issues/add-select`) と同じ並び・カード構造を踏襲しつつ、
 * Value の場合は「種別選択」ではなく「追加経路選択」のため RadioGroup を
 * 使わずに各カード自体を押下で遷移する単純構造にしている。
 */
export const Route = createFileRoute('/_stacktrace/values/add-select/')({
  component: ValueAddSelectRouteComponent,
});

function ValueAddSelectRouteComponent() {
  const { t } = useTranslation(stacktraceNS, {
    keyPrefix: 'values.addSelect',
  });
  useDocumentTitle(t('pageTitle'));
  return <ValueTypeSelectionPage />;
}
